import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import * as constants from '../constants';

const initialState = {
    errorGetApplication: '',
    appForm: {
        kycId: '',
        price: '',
        make: '',
        model: '',
        variant: '',
        loanAmount: '',
        tenure: '',
        interestRate: '',
        leaseRental: '',
        name: '',
        identityNo: '',
        consent: {},
        applicationFormConsentViewModel: [],
    },
    applicantDetails: constants.applicantDetails,
    fetching: false,
};

const getApplicationReducer = (state = initialState, action) => {
    switch (action.type.type) {
        case actionTypes.GET_APPLICATION_DETAILS_SUCCESS:
            const appFormPayload = action.type.response.data.applicationDetails;
            appFormPayload.isLease = appFormPayload.product === 'ol';
            return updateObject(state, {
                errorGetApplication: '',
                appForm: appFormPayload,
                applicantDetails: action.type.response.data.applicantDetails,
                clientDefaultPhoneNo: action.type.response.data.ClientDefaultPhoneNo,
                fetching: false,
            });

        case actionTypes.GET_APPLICATION_DETAILS_FAILED:
            return updateObject(state, {
                errorGetApplication: action.type.error,
                fetching: false,
            });

        case actionTypes.GET_APPLICATION_DETAILS_START:
            return updateObject(state, { fetching: true });

        default: {
            return state;
        }
    }
};

export default getApplicationReducer;
